<template>
  <div class="style-button-group">
    <ix-router-link class="button grey"
      v-for="gallery in galleries" :to="gallery.url" :key="'gb' + gallery.gallery_id">{{ gallery.name }}</ix-router-link>
  </div>
</template>

<script>
export default {
  props: {
    value: Object
  },
  data () {
    return {
      galleries: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData: async function () {
      let galleries = await this.$store.dispatch('fetchGalleries')
      let gals = galleries.filter(el => (el.animation))
      gals = gals.sort((el, el2) => { return el.name.localeCompare(el2.name) })
      if(this.value) {
        let cat = this.value.category
        this.galleries = gals.filter(el => el.category === cat)
      }
     
    }
  },
  watch: {
    value () {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.style-button-group{
  display:flex;
  flex-wrap: wrap;
  margin:0 0 24px 0;
}

.style-button-group .nav-button{
  margin-bottom:5px;
}

</style>
